import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { TabContext, TabPanel } from "@mui/lab";
import { Box, Divider, Tab, Tabs } from "@mui/material";

import { RiskRegister } from "../components/RiskRegister";
import { RiskOverView } from "../components/RiskOverview";

export const RiskAndIssues: React.FC = () => {

    const navigate = useNavigate();
    const { projectId, portfolioId, portfolioName, projectName } = useParams();

    const [searchParams] = useSearchParams();
    const tab = searchParams.get('tab') || 'overview';

    const handleChangeTab = (_e: React.SyntheticEvent, tab: "overview" | "risk-register") => {
        if (portfolioId && portfolioName) {
            navigate(`/portfolio/projects/${portfolioId}/${portfolioName}/${projectId}/${projectName}/risk-dashboard?tab=${tab}`, { replace: true });
        } else if (projectId && projectName) {
            navigate(`/project/${projectId}/${projectName}/risk-dashboard?tab=${tab}`, { replace: true });
        } else {
            navigate(`/risk-dashboard?tab=${tab}`, { replace: true });
        }
    };

    if (!tab) {
        return <div>Project ID or Risk Section is missing</div>;
    };

    return (
        <Box flex={1} height={'100%'} display={'flex'} flexDirection={'column'}>
            <TabContext value={tab}>
                <Box display="flex" alignItems="center" alignContent="center">
                    <Tabs
                        value={tab}
                        onChange={handleChangeTab}
                        aria-label="Tabs"
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{ minHeight: "auto" }}
                    >
                        <Tab
                            sx={{ height: "auto", minHeight: "auto" }}
                            label={'Overview'}
                            value={'overview'}
                        />
                        <Tab
                            sx={{ height: "auto", minHeight: "auto" }}
                            label={'Risk Register'}
                            value={'risk-register'}
                        />
                    </Tabs>
                </Box>
                <Divider />
                <Box flex={1} overflow="hidden">
                    <TabPanel value="overview" sx={{ p: 0, height: "100%", overflowY: 'auto' }}>
                        <RiskOverView projectId={projectId} />
                    </TabPanel>
                    <TabPanel value="risk-register" sx={{ p: 0, height: "100%", overflowY: 'auto' }}>
                        <RiskRegister projectId={projectId} />
                    </TabPanel>
                </Box>
            </TabContext>
        </Box>
    );
};